import { DateTime } from "luxon";

type AddWorkingDaysOptions = {
    dayOfWeek?: number;
    skipDaysStr?: string;
    holidayDates?: IShippingHoliday[];
};
export interface IShippingHoliday {
    id?: string;
    date?: string;
}
export const addWorkingDays = (dateIn: Date, shift: number, options?: AddWorkingDaysOptions) => {
    const opt = {
        dayOfWeek: options?.dayOfWeek || -1,
        skipDaysStr: options?.skipDaysStr,
        holidayDates: options?.holidayDates
    };

    let { skipDaysStr } = opt;
    const { holidayDates } = opt;

    const dateOut = new Date(dateIn);

    if (!skipDaysStr && skipDaysStr !== "") {
        skipDaysStr = "0,6"; // Skip Saturday and Sunday by default
    }

    const skipDays = skipDaysStr.split(",");

    // Iterate through shift variable skipping past non-working days
    for (let i = 0; i <= shift; i++) {
        if (i !== 0) {
            dateOut.setDate(dateOut.getDate() + (shift < 0 ? -1 : 1));
        }

        // skip days of the week
        while (shouldSkip(dateOut, skipDays, holidayDates)) {
            dateOut.setDate(dateOut.getDate() + (shift < 0 ? -1 : 1));
        }
    }

    return dateOut;
};
const shouldSkip = (date: Date, skipDays: string[], holidayDates?: IShippingHoliday[]) => {
    const dateOut = new Date(date);
    return skipDays.includes(dateOut.getDay().toString()) || isHolidayDate(dateOut, holidayDates);
};
export const isHolidayDate = (date: Date, holidayDates?: IShippingHoliday[]) => {
    if (!holidayDates) {
        return false;
    }
    const dateTime = DateTime.fromJSDate(date);
    return holidayDates.some(h => {
        const holidayDate = DateTime.fromISO(h.date || "");
        if (!holidayDate.isValid) {
            return false;
        }
        return (
            holidayDate.hasSame(dateTime, "day") &&
            holidayDate.hasSame(dateTime, "month") &&
            holidayDate.hasSame(dateTime, "year")
        );
    });
};